import {
	ClickAwayListener,
	Grid,
	ListItemButton,
	Paper,
	styled,
	Tooltip,
	Typography
} from "@mui/material";
import { useContext, useState } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import Context from "../context";

const ListItemBtn = styled(ListItemButton)<{ hasCopied: boolean }>(({ theme, hasCopied }) => ({
	backgroundColor: hasCopied ? theme.palette.success.main : theme.palette.primary.main,
	justifyContent: "center",
	borderTopRightRadius: 7,
	borderBottomRightRadius: 7,
	overflow: "hidden",
	":hover": {
		backgroundColor: hasCopied ? theme.palette.success.darker : theme.palette.primary.darker
	}
}));

export default function SecretPaper() {
	const { state } = useContext(Context);
	const [hasCopied, setHasCopied] = useState(false);
	const [open, setOpen] = useState(false);
	const { translate } = useLocales();

	const copyToClipboard = async () => {
		await navigator.clipboard.writeText(state.secret);
		setOpen(true);
		setHasCopied(true);
	};

	const handleTooltipClose = () => {
		setOpen(false);
	};

	return (
		<Paper elevation={3}>
			<Grid container>
				<Grid item sm={10} xs={12}>
					<Typography variant='subtitle2' color='text.primary' sx={{ pl: 2, py: 2 }}>
						{state.secret}
					</Typography>
				</Grid>
				<Grid item sm={2} xs={12}>
					<ClickAwayListener onClickAway={handleTooltipClose}>
						<Tooltip
							PopperProps={{
								disablePortal: true
							}}
							onClose={handleTooltipClose}
							open={open}
							disableFocusListener
							disableHoverListener
							disableTouchListener
							title={translate("app_secrets.copied")}
						>
							<ListItemBtn sx={{ py: 2.1 }} onClick={copyToClipboard} hasCopied={hasCopied}>
								{!hasCopied ? (
									<Typography variant='subtitle2' color='background.paper'>
										{translate("app_secrets.copy")}
									</Typography>
								) : (
									<Iconify icon={"mdi:success"} color={"background.paper"} />
								)}
							</ListItemBtn>
						</Tooltip>
					</ClickAwayListener>
				</Grid>
			</Grid>
		</Paper>
	);
}
